import { render, staticRenderFns } from "./static_required_dropdown_field.vue?vue&type=template&id=2d35ec3a"
import script from "./static_required_dropdown_field.vue?vue&type=script&lang=js"
export * from "./static_required_dropdown_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports